import { StoreSchema } from '../../types/store'

export const selectInfo = (store: StoreSchema) => store.info.info